import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'aa-spinning-loader-alt',
    templateUrl: './spinning-loader-alt.component.html',
    styleUrls: [
        './spinning-loader-alt.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SpinningLoaderAltComponent
{
    // private static sizes: string[] = ['small', 'medium', 'large'];
    // private static colors: string[] = ['white', 'blue'];
    // private static srcRoot: string = 'assets/images/spinner/';
    @Input() loading: boolean;
    @Input() size: number = 0;
    @Input() color: number = 1;
    // public srcSVG: string = SpinningLoaderAltComponent.srcRoot + 'blue/small.svg';
}
